/* © CNES */
import { createInstance, MatomoProvider } from '@jonkoops/matomo-tracker-react';
import { MatomoInstance } from '@jonkoops/matomo-tracker-react/lib/types';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import '../node_modules/primeflex/primeflex.css';
import { apiConfiguration } from './api/APIConfiguration';
import App from './App';
import './index.scss';
import reportWebVitals from './reportWebVitals';

const matomoInstance =
  process.env.NODE_ENV === 'production'
    ? createInstance({
        urlBase: apiConfiguration.matomo.url,
        siteId: apiConfiguration.matomo.siteId,
        // trackerUrl, -> defaults to @/matomo.php
        // srcUrl, -> defaults to @/matomo.js
        linkTracking: false,
      })
    : null;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {process.env.NODE_ENV === 'production' ? (
      <MatomoProvider value={matomoInstance as MatomoInstance}>
        <App />
      </MatomoProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
